// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"badgeIcon_r-mobile__NAe2w","r-not-mobile":"badgeIcon_r-not-mobile__QiWSD","container":"badgeIcon_container__3cX9q"};